<template>
<div>
  <v-switch data-operator="corporation"
      v-model="corporation"
      :label="`Operator is corporation`"
    ></v-switch>
    <operator-individual v-if="!corporation" :operator="operator"/>
    <operator-corporation v-if="corporation" :operator="operator"/>

</div>
</template>

<script>
import OperatorIndividual from "./OperatorIndividual.vue";
import OperatorCorporation from "./OperatorCorporation.vue";

export default {
  components: {
    OperatorIndividual,
    OperatorCorporation
  },
  data: () => ({
      corporation : false
  }),
  props: ["operator"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
